export default __webpack_public_path__ + "static/media/eyeofthestorm.f7121c38.png";